var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5608 4H19.4122C18.8599 4 18.4122 4.44772 18.4122 5V12C18.4122 12.5523 17.9645 13 17.4122 13H5.44598C4.89369 13 4.44598 13.4477 4.44598 14V15C4.44598 15.55 4.92943 16 5.5203 16H16.9445C17.1973 16 17.4408 16.0958 17.6258 16.268L19.9538 18.435C20.5934 19.0303 21.6352 18.5767 21.6352 17.703V5C21.6352 4.45 21.1517 4 20.5608 4ZM15.1892 11C15.7801 11 16.2635 10.55 16.2635 10V1C16.2635 0.45 15.7801 0 15.1892 0H1.22301C0.632128 0 0.148682 0.45 0.148682 1V12.703C0.148682 13.5768 1.19046 14.0303 1.83002 13.435L4.15803 11.268C4.34309 11.0958 4.58654 11 4.83937 11H15.1892ZM2.93118 9.59C2.68839 9.81216 2.29733 9.63992 2.29733 9.31083V3C2.29733 2.44771 2.74505 2 3.29733 2H13.1149C13.6672 2 14.1149 2.44772 14.1149 3V8C14.1149 8.55229 13.6672 9 13.1149 9H3.95261C3.69684 9 3.45078 9.09801 3.26506 9.27387L2.93118 9.59Z",
    fill: "#605DEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/Comments.633b101bc9bc9b270ba4d62297967088.svg";
export { ForwardRef as ReactComponent };